import { installSgtmPathRewrite } from '../helpers';
export default function init(defaultMediaChannel = null) {
    var _a;
    const excludedDomains = [
        'go.jacuzzi.com',
        'modernize.com'
    ];
    const sGTMEnabledDomains = ['mygutterguards.com'];
    let shouldApplyDynamicGtm = true;
    // Check current page against excluded domains
    const hostname = window.location.hostname.replace(/^(qa\.|www\.)+/, '');
    const pathname = window.location.pathname;
    // Check if domain should be excluded
    const isExcludedDomain = excludedDomains.some(domain => hostname === domain);
    // Exception: allow modernize.com/quote/* paths
    const isModernizeQuotePath = hostname === 'modernize.com' && pathname.startsWith('/quote/');
    if (isExcludedDomain && !isModernizeQuotePath) {
        shouldApplyDynamicGtm = false;
    }
    let sGTMEnabled = false;
    // Dynamic GTM containers based on traffic source (only if not excluded)
    if (shouldApplyDynamicGtm) {
        const gtmContainers = {
            'sem': 'GTM-5WM2R5WC',
            'avm': 'GTM-W3WNB6FZ',
            'pub': 'GTM-NLNXPRZX',
            'hb': 'GTM-NLNXPRZX'
        };
        const sGTMEnabledContainers = {
            'sem': 'GTM-KZFMZR73'
        };
        const mediaChannel = (_a = window.modUtils) === null || _a === void 0 ? void 0 : _a.getTrafficSource();
        if (mediaChannel && gtmContainers[mediaChannel]) {
            gtm_container_ID = gtmContainers[mediaChannel];
        }
        else if (defaultMediaChannel && gtmContainers[defaultMediaChannel]) {
            gtm_container_ID = gtmContainers[defaultMediaChannel];
        }
        const channel = mediaChannel || defaultMediaChannel;
        if (channel === 'sem' && sGTMEnabledDomains.includes(hostname)) {
            gtm_container_ID = sGTMEnabledContainers[channel];
            sGTMEnabled = true;
        }
    }
    if (sGTMEnabled) {
        installSgtmPathRewrite();
        (function (w, d, s, l) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '?l=' + l : ''; j.async = true; j.src = '/scripts/' + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer');
    }
    else {
        (function (w, d, s, l, i) {
            var _a;
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            let f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            (_a = f.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(j, f);
            j.onload = () => { const gtmLoadEvent = new CustomEvent('modgtm.loaded'); document.dispatchEvent(gtmLoadEvent); };
        })(window, document, 'script', 'dataLayer', gtm_container_ID);
    }
}
